module.exports = __webpack_public_path__ + "img/685.72de9eff.jpg";